import { render, staticRenderFns } from "./EmployeeDisplayComponent.vue?vue&type=template&id=088499f8&"
import script from "./EmployeeDisplayComponent.vue?vue&type=script&lang=js&"
export * from "./EmployeeDisplayComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports